import Gooey, { calc, field, mount } from '@srhazi/gooey';

import { Keyboard } from './modes/Keyboard';

import './modes.css';

const ready = field(false);

const app = document.getElementById('app');
if (!app) {
    alert('RUH ROH, no #app element found');
} else {
    mount(
        app,
        <>
            <h1>Modes</h1>
            {calc(() =>
                !ready.get() ? (
                    <button on:click={() => ready.set(true)}>
                        Click to initialize audio & start
                    </button>
                ) : (
                    <Keyboard />
                )
            )}
        </>
    );
}
